import {_request, _requestForm} from "./api";

export const item = (player_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `medical/${player_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const setMedical = (date, player_guid) => {
    let params = date
    return new Promise((resolve, reject) => {
        return _requestForm({
            target: `medical/${player_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const remove = (season_medical_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `medical/${season_medical_guid}`, method: 'DELETE'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};